import React from 'react'
import { Typography } from 'antd'

const { Text } = Typography

const Detail = ({ header, children }) => (
    <div style={{ display: 'flex', flexDirection: 'column', width: '100%'}}>
        { header && <Text style={{ marginRight: '10px', fontSize: '.75rem', textTransform: 'capitalize' }}>{header}</Text> }
        { children }
    </div>
)

export const UserDetails = ({ type, user, name, style }) => {
    if (!user) return null

    const formatPhoneNumber = (phone) => {
        if (!phone) return ''
        const cleaned = phone.replace(/\D/g, '')
        if (cleaned.length === 10) {
            return `(${cleaned.slice(0,3)}) ${cleaned.slice(3,6)}-${cleaned.slice(6)}`
        }
        return phone
    }

    const formatDate = (date) => {
        if (!date) return ''
        try {
            return new Date(date).toLocaleDateString('en-US', {
                month: '2-digit',
                day: '2-digit',
                year: 'numeric'
            })
        } catch {
            return date
        }
    }

    return (
        <div style={{ 
            display: 'grid', 
            gridTemplateColumns: '20% 22.5% 22.5% 17.5% 17.5%',
            background: '#FAFBFC',
            justifyContent: 'left',
            minWidth: '800px',
            padding: '0 20px',
            ...style
        }}>
            <Detail header={type}>
                <div style={{ fontWeight: 'bolder', fontSize: '.75rem'}}>
                    {name}
                    { user.deaNumber && <div style={{ fontWeight: 'bolder', fontSize: '.75rem'}}>DEA Number: {user.deaNumber}</div> }
                </div>
            </Detail>
            { user.address1 && (
                <Detail header='Address'>
                    <div style={{ fontWeight: 'bolder', fontSize: '.75rem'}}>{user.address1}</div>
                    { user.address2 && <div style={{ maxWidth: '180px', fontWeight: 'bolder', fontSize: '.75rem'}}>{user.address2}</div> }
                    <div style={{ fontWeight: 'bolder', fontSize: '.75rem'}}> {`${user.city}, ${user.stateName || user.state} ${user.zipCode}`}</div>
                </Detail>
            ) }
            { (user.phone || user.email ) && (
                <Detail header='Contact Info'>
                    { user.phone && <div style={{ fontWeight: 'bolder', fontSize: '.75rem'}}>{formatPhoneNumber(user.phone)}</div> }
                    { user.email && <div style={{ fontWeight: 'bolder', fontSize: '.75rem'}}> {user.email}</div> }
                </Detail>
            )} 
            {
                user.gender && (
                    <Detail header='Gender/DOB'>
                        <div style={{ fontWeight: 'bolder', fontSize: '.75rem'}}>{`${user.gender.toUpperCase()},  ${formatDate(user.dob)}`}</div>
                    </Detail> 
                )
            }
            {
                user.heightFt && (
                    <Detail header='Height/Weight'>
                        <div style={{ fontWeight: 'bolder', fontSize: '.75rem'}}>{`${user.heightFt}ft ${user.heightIn}in / ${user.weight}lbs`}</div>
                    </Detail>
                )
            }
        </div>
    )
}
